export const STATUS_COLORS_MAP = {
  APPROVED: { success: true },
  COMPLETE: { success: true },
  PENDING_MASTER: { warning: true },
  EDITING: { success: true },
  INTERNAL_REVIEW: { internal: true },
  PENDING_REVIEW: { internal: true },
  DRAFT: { neutral: true }
} as const;
